import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcCancelCall24Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton, IconViewSizes, PopoverMenu } from '@gem/ui-kit';

import styles from './FinishCallButton.styles.m.css';
import { useFinishCallButtonPresenter } from './presenter/FinishCallButton.presenter';

export const FinishCallButton: FC = observer(() => {
  const { presenter, buttonRef } = useFinishCallButtonPresenter();
  const { t } = useTranslation();

  return (
    <>
      <IconButton
        isDisabled={presenter.disabledFinishCall}
        setRef={buttonRef}
        Icon={IcCancelCall24Icon}
        onClick={presenter.finishCall}
        size={IconViewSizes.Big}
        iconSize={IconViewSizes.Medium}
        theme="9"
        iconClassName={styles.icon}
        dataTest="callview-call-actions-panel-finish-call-button"
      />
      <PopoverMenu
        className={styles.popover}
        isOpened={presenter.isOpened}
        placement="top-end"
        menuItems={[
          {
            key: 'finishAll',
            title: t('calls_end_for_all'),
            onClick: presenter.finishAll,
          },
          {
            key: 'leave',
            title: t('calls_leave_meeting'),
            onClick: presenter.leaveCall,
          },
        ]}
        reference={buttonRef.current}
        onClose={presenter.closePopover}
        theme={'dark'}
      />
    </>
  );
});
